<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">客户基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="112px"
          ref="customer"
          :formConfig="formConfig"
          v-model="form"
          :disabled="openLook"
          :showBtn="showBtn"/>
      </div>
      <folded-panel infoName="客户关键信息">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.clientKeyInformation"
            :editable="true"
            :edit-rules="validRules"
            :config="{trigger: 'click', mode: 'cell', autoClearActive:false}"
            :showAdd="true"
            :data.sync="tableData"
            height=""
          >
          <template #logoType="{row}">
              <div v-for="item in logoTypes" :key="item.id">
                  <div v-if="row.logoType && row.logoType.toString() === item.value">{{item.label}}</div>
              </div>
            </template>
            <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delCustomerInformation($index)"></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="客户联系人信息">
        <div slot="content">
          <edit-data-table
            :head="editTable.clientContactInformation"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive:false }"
            :showAdd="editTable.showAdd"
            :edit-rules="validRules"
            :data.sync="tableData1"
            :editable="true"
            :showNumber="true"
            height=""
          >
            <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delContactCustomer($index)"></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="客户账号信息">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.clientAccountInformation"
            :editable="editTable.enableEdit"
            :config="{ trigger: 'click', mode: 'cell' }"
            :showAdd="editTable.showAdd"
            :border=true
            :data.sync="tableData2"
            height=""
          >
            <template #toolbar="{$index}">
              <el-button icon="el-icon-delete" type="text" size="mini" @click="delCustomerAccount($index)"></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" @click="submit">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel"
  import "@/components/dynamic-form"
  import '@/components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import { deepClone } from '@/utils/index'
  import initDict from "@/mixin/initDict";
  import { addCustomer, modifyCustomer, removeBsContactCustomer, removeBsCustomerAccount, removeBsCustomerInformation, findCustomerById } from '@/api/basic/customer'

  export default {
    name: "CustomerForm",
    components: { FoldedPanel },
    mixins: [DataTableMixin,initDict],
    data() {
      return {
        tableData: [],
        tableData1: [],
        tableData2: [],
        validRules: {
          logoType: [{ required: true, message: "标识类型不能为空", trigger: "blur" }],
          logoNumber: [{ required: true, message: "标识号不能为空", trigger: "blur" }],
          name: [{ required: true, message: "联系人名称不能为空", trigger: "blur" }],
        },
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "code",
              label: "客户代码",
              value: "",
              span: 8,
               rules: [
                {required: true, message: "客户法定名称不能为空", trigger: "blur"},
                {
                  pattern: "^[^\u4e00-\u9fa5]{0,}$",
                  message: "客户代码不能含有中文",
                  trigger: "blur"
                },
              ]
            },
            {
              type: "input",
              key: "name",
              label: "客户法定名称",
              value: "",
              span: 8,
              rules: [
                {required: true, message: "客户法定名称不能为空", trigger: "blur"}
              ]
            },
            {
              type: "text",
              showWordLimit: true,
              key: "shortName",
              label: "客户简称",
              value: "",
              maxlength: "10",
              minlength: "4",
              span: 8,
              rules: [
                {required: true, message: "客户简称不能为空", trigger: "blur"}
              ]
            },
            {
              type: "input",
              key: "detailedAddress",
              label: "客户详细地址",
              value: "",
              span: 8
            },
            {
              type: "input",
              key: "phone",
              label: "客户电话",
              value: "",
              span: 8
            },
            {
              type: "input",
              key: "email",
              label: "客户邮编",
              value: "",
              span: 8
            },
            {
              type: "input",
              key: "fax",
              label: "客户传真",
              value: "",
              span: 8
            },
            {
              span: 8,
              type: "select",
              label: "客户类型",
              key: "customerType",
              value: "",
              disabled: false,
              multiple: false,
              placeholder: "请选择",
              options: []
            },
            {
              label: '行业',
              key: 'industryId',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: ''
              },
              url: '/industry',
              tableColumn: [
                {
                  property: "code",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
            },
            // {
            //   label: '母公司',
            //   key: 'parentId',
            //   type: 'databox',
            //   span: 8,
            //   props: {
            //     label: 'name',
            //     value: ''
            //   },
            //   url: '/customer',
            //   tableColumn: [
            //     {
            //       property: "code",
            //       label: "编码",
            //       query: {
            //         type: 'input'
            //       }
            //     },
            //     {
            //       property: "name",
            //       label: "名称",
            //       query: {
            //         type: 'input'
            //       }
            //     }
            //   ],
            //   extendParms: {queryFieldItem: 'id,number,name'},
            //   multiple: false,
            // },
            {
              type: "textarea",
              key: "remark",
              label: "备注",
              value: "",
              placeholder: "请输入备注",
              span: 20
            }
          ]
        },
        showBtn: false,
        openLook: false,
        form: {},
        editTable: {
          showNumber: true,
          enableEdit: true,
          showAdd: true,
          clientKeyInformation: [
            {
              label: '标识类型',
              prop: 'logoType',
              editRender: { type: 'default', name: 'ElSelect', options: [] },
            },
            {
              label: '标识号',
              prop: 'logoNumber',
              editRender: { type: 'default', name: 'ElInput' }
            },
          ],
          clientContactInformation: [
            {
              label: '联系人名称',
              prop: 'name',
              width: '120px',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '关键',
              prop: 'crux',
              formatter: this.curxFormatter,
              editRender: { type: 'default', name: 'ElSelect', options: [
                  { value: 1, label: '是' },
                  { value: 0, label: '否' },
                ] },
            },
            {
              label: '固定电话',
              prop: 'telephoneNumber',
               width: '100px',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '手机',
              prop: 'phone',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '邮箱',
              prop: 'email',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '办公地址',
              prop: 'companyAddress',
              width: '100px',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '邮编',
              prop: 'zipCode',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '职位',
              prop: 'position',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '负责业务',
              prop: 'responsibleBusiness',
              width: '100px',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '生日',
              prop: 'birthday',
              editRender: {name: 'ElDatePicker', props: {type: 'date', valueFormat: 'yyyy-MM-dd'}}
            },
            {
              label: '备注',
              prop: 'remark',
              editRender: { type: 'default', name: 'ElInput' }
            },
          ],
          clientAccountInformation: [
            {
              label: '付款/开票行银行代码',
              prop: 'makeInvoiceAccount',
              width: '156px',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '付款/开票行账号',
              prop: 'invoiceAccount',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '银行明细标识',
              prop: 'bankDetailsIdentifying',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '银行国家代码',
              prop: 'bankCountryCode',
              editRender: { type: 'default', name: 'ElSelect', options: [] }
            },
            {
              label: '客户开票银行标识',
              prop: 'customerInvoiceLogo',
              editRender: { type: 'default', name: 'ElInput' }
            },
            {
              label: '参考明细',
              prop: 'consultDetails',
              editRender: { type: 'default', name: 'ElInput' }
            },
          ]
        },
        logoTypes: []
      }
    },
    created() {
      this.initData()
      // 客户类型
      this.getDict("customer_type").then(res => {
       this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'customerType')].options = res.data;
      });
       // 标识类型
      this.getDict("customer_logo_type").then(res => {
        this.logoTypes = res.data;
      this.editTable.clientKeyInformation[this.editTable.clientKeyInformation.findIndex(ele => ele.prop === 'logoType')].editRender.options = res.data;
      });
        // 银行国家代码
      this.getDict("bank_code").then(res => {
      this.editTable.clientAccountInformation[this.editTable.clientAccountInformation.findIndex(ele => ele.prop === 'bankCountryCode')].editRender.options = res.data;
      });
    },
    methods: {
      curxFormatter(val) {
        if (val === 0) {
          return '否'
        } else if (val === 1) {
          return '是'
        } else {
          return ''
        }
      },
      delCustomerInformation(index) {
        if (this.tableData[index].id) {
          removeBsCustomerInformation(this.tableData[index].id).then(res => {
            this.tableData.splice(index, 1)
          })
        } else {
          this.tableData.splice(index, 1)
        }
      },
      delContactCustomer(index) {
        if (this.tableData1[index].id) {
          removeBsContactCustomer(this.tableData1[index].id).then(res => {
            this.tableData1.splice(index, 1)
          })
        } else {
          this.tableData1.splice(index, 1)
        }
      },
      delCustomerAccount(index) {
        if (this.tableData2[index].id) {
          removeBsCustomerAccount(this.tableData2[index].id).then(res => {
            this.tableData2.splice(index, 1)
          })
        } else {
          this.tableData2.splice(index, 1)
        }
      },
      async initData() {
        if (this.$route.query.id) {
          const result = await findCustomerById(this.$route.query.id)
          const form = result.data.bsCustomer
          if (form.industry) {
            form.industryId = { id: form.industryId, name: form.industry.name }
          }
          if (form.customer) {
            form.parentId = { id: form.parentId, name: form.customer.name }
          }
          this.form = form
          this.tableData = result.data.customerInformations
          this.tableData1 = result.data.bsContactCustomers
          this.tableData2 = result.data.bsCustomerAccounts
        }
      },
      submit() {
        this.$refs["customer"].validate().then(() => {
          const bsCustomer = deepClone(this.form)
          if (bsCustomer.industryId) {
            bsCustomer.industryName = bsCustomer.industryId.name
            bsCustomer.industryId = bsCustomer.industryId.id
          }
          if (bsCustomer.parentId) {
            bsCustomer.parentName = bsCustomer.parentId.name
            bsCustomer.parentId = bsCustomer.parentId.id
          }
          for (const i of this.tableData) {
            if (!i.logoType) {
              return this.$notify({ title: "标识类型不能为空！", type: "error", duration: 2500 })
            }
             if (!i.logoNumber) {
              return this.$notify({ title: "标识号不能为空！", type: "error", duration: 2500 })
            }
          }
          for (const i of this.tableData1) {
            if (!i.name) {
              return this.$notify({ title: "客户联系人名称不能为空！", type: "error", duration: 2500 })
            }
          }
          if (this.form.id) {
            modifyCustomer({
              bsCustomer,
              customerInformations: this.tableData,
              bsContactCustomers: this.tableData1,
              bsCustomerAccounts: this.tableData2
            }).then(res => {
              this.$notify({
              title: "操作成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
            })
          } else {
            addCustomer({
              bsCustomer,
              customerInformations: this.tableData,
              bsContactCustomers: this.tableData1,
              bsCustomerAccounts: this.tableData2
            }).then(res => {
              this.$notify({
              title: "操作成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
            })
          }
        })
      },
      cancel() {
         this.$router.go(-1);
      }
    }

  }
</script>

<style lang="scss" scoped>
  .app-container {
    .box-card {
      background-color: #fff;
      padding: 20px 30px 20px 30px;
      border-radius: 10px;
      .content-title {
        height: 40px;
        background-color: #e7eff6;
        padding-left: 20px;
        overflow: hidden;
        .title-icon {
          display: inline-block;
          margin-top: 8px;
          width: 4px;
          height: 24px;
          background-color: #1369a8;
          margin-right: 14px;
        }
        .title-details {
          overflow: hidden;
          line-height: 20px;
          display: inline-block;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          font-family: SourceHanSansSC-regular;
        }
      }
      .button {
        padding-top: 20px;
        text-align: right;
        .btn-submit {
          width: 80px;
          height: 38px;
          background: #1369a8;
          color: white;
        }
        .btn-cancel {
          width: 80px;
          height: 38px;
          background: #fff;
        }
      }
    }
  }
</style>
